import React from "react";
import Calculator from "./containers/Calculator/Calculator";
import "./App.css";
import { Switch, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
      {/* <Switch>
        <Route exact path="/" component={Calculator} />
      </Switch> */}
      <Calculator />
    </div>
  );
}

export default App;
